import classNames from 'classnames'
import React from 'react'
import PropTypes from 'prop-types'

import {NavToggle} from './NavToggle'

export default function Nav({data}) {
  const {items, modifier} = data
  const classes = classNames('c-nav', {
    [`c-nav--${modifier}`]: modifier,
  })

  return (
    <nav className={classes}>
      <ul className="c-nav__list">
        {items.map((item) => (
          <NavToggle key={item.id} data={item} modifier={modifier} />
        ))}
      </ul>
    </nav>
  )
}

Nav.propTypes = {
  data: PropTypes.shape({
    modifier: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
}
